function closeAllMenusAndModals()
{
  $(".scs-currency-block .dropdown-toggle .dropdown-menu").hide();
  $(".close-menu-mb").removeClass("menu-open");
  $(".cart-sidebar-products").hide();
  $("#sidebar-cart").hide();
  $("#dropdown-cart").slideUp();
  $("[data-popup-video]").hide();
  $("[data-ajax-cart-success]").hide();
  $("html").removeClass("sidebar-open");
  $("#dropdown-customer").slideUp();
  $(".compare-modal").hide();
}

async function getProductInfo(productHandle) {
  return new Promise((resolve) => {
    jQuery.ajax({
          dataType: "json",
          url: window.router + "/products/" + productHandle + ".js",
          cache: !1,
          success: function (e) {
            resolve(e);
          },
          error: function (e) {
            resolve(e);
          },
        });
    });
}

async function getPrductsInfo(productHandles) {
  return new Promise((resolve) => {
    let retval = [];
    let promises = [];
    for (let handle of productHandles) {
      promises.push(new Promise((resolveInner) => {
        getProductInfo(handle).then((e) => {
          retval[handle] = e;
          resolveInner();
        }, function () {
          retval[handle] = false;
          resolveInner();
        });
      }));
    }
    return Promise.all(promises).then(() => resolve(retval));
  });
}

$(document).ready(function(){
 
  setTimeout( () => {
    $(".video-open-popup a")
      .on("click", function () {
        var video_id = $(this).attr("data-id"),
          video_src = $(this).attr("data-src"),
          modal = $("[data-popup-video]");

        const $content =
          '<div class="fluid-width-video-wrapper"><iframe\
                                      id="player"\
                                      type="text/html"\
                                      width="100%"\
                                      frameborder="0"\
                                      webkitAllowFullScreen\
                                      mozallowfullscreen\
                                      allowFullScreen\
                                      src="https://www.youtube.com/embed/' +
          video_src +
          '?autoplay=1&mute=1"\
                                      data-video-player>\
                                  </iframe></div>';
        modal.find(".halo-modal-body").html($content);
  
        modal.fadeIn(600, function () {
          if ($("[data-ajax-cart-success]").is(":visible")) {
            $("[data-ajax-cart-success]").hide();
          }
        });
    });
  }, 0);

  setTimeout( () => {
    $("[data-popup-video], [data-popup-video] .close-modal").on(
      "click",
      function (e) {
        var modalContent = $("[data-popup-video] .halo-modal-body");
        if (
          !modalContent.is(e.target) &&
          !modalContent.has(e.target).length
        ) {
          $("[data-popup-video]").fadeOut(500, function () {
            $("[data-popup-video] iframe").remove();
            $("html").removeClass("halo-modal-open");
            $("html").css({
              overflow: "",
            });
          });
        }
      }
    );
  },0);



  function addWorkDays(startDate, days) {
      if(isNaN(days)) {
          console.log("Value provided for \"days\" was not a number");
          return
      }
      if(!(startDate instanceof Date)) {
          console.log("Value provided for \"startDate\" was not a Date object");
          return
      }
      // Get the day of the week as a number (0 = Sunday, 1 = Monday, .... 6 = Saturday)
      var dow = startDate.getDay();
      var daysToAdd = parseInt(days);
      // If the current day is Sunday add one day
      if (dow == 0)
          daysToAdd++;
      // If the start date plus the additional days falls on or after the closest Saturday calculate weekends
      if (dow + daysToAdd >= 6) {
          //Subtract days in current working week from work days
          var remainingWorkDays = daysToAdd - (5 - dow);
          //Add current working week's weekend
          daysToAdd += 2;
          if (remainingWorkDays > 5) {
              //Add two days for each working week by calculating how many weeks are included
              daysToAdd += 2 * Math.floor(remainingWorkDays / 5);
              //Exclude final weekend if remainingWorkDays resolves to an exact number of weeks
              if (remainingWorkDays % 5 == 0)
                  daysToAdd -= 2;
          }
      }
      startDate.setDate(startDate.getDate() + daysToAdd);
      return startDate;
  }

  
  setTimeout( () => {
    $("#comparebutton").click(function () {
      showLoading();
      $("#compare-table").empty();

      let ItemsToCompare = localStorage.getItem("ItemsToCompare") || "{}";
      try {
        ItemsToCompare = JSON.parse(ItemsToCompare);
      } catch (err) {
        ItemsToCompare = {};
      }
      
      // mdata fix
      if (Object.keys(ItemsToCompare).length > 0  && ItemsToCompare[Object.keys(ItemsToCompare)[0]].hasOwnProperty("mdata") == false)
      {
        localStorage.setItem("ItemsToCompare",'{}')
        ItemsToCompare = {};
      }

      if (Object.keys(ItemsToCompare).length > 0 )
      {
        $("#compare-notification").hide();
      }
      else
      {
        $("#compare-notification").show();
      }

      
      
      let productInfos = getPrductsInfo(Object.keys(ItemsToCompare)).then((productJSONs)=>{ 

          let multivariantprod = false;
          for (let prod of Object.keys(productJSONs))
          {
            if (productJSONs[prod] == false)
            {
              // if product no longer available
              delete productJSONs[prod];
              delete ItemsToCompare[prod];
              localStorage.setItem("ItemsToCompare", JSON.stringify(ItemsToCompare));

              // update visually
              $(".comparebuttonamount").text(Object.keys(ItemsToCompare).length);
          
              if (Object.keys(ItemsToCompare).length > 1) {
                $("#comparebutton").addClass("fa-bounce");
              } else {
                $("#comparebutton").removeClass("fa-bounce");
              }
              continue;
            }
            let el = productJSONs[prod];
            if (el.variants.length > 1)
            {
              multivariantprod = true;
            }
          };

        
          // Image
          let row = $("<div class='compare-row' style='width: 100%; max-width: 100%; display: block;'></div>");
          let index = 0;
          for (let prod of Object.keys(productJSONs))
          {
            if (productJSONs[prod] == false)
              continue;
            
            let metadata = JSON.parse(atob(ItemsToCompare[prod].mdata));
            //console.log(metadata);

            
            let comparecol = $("<form method='post' action='/cart/add' enctype='multipart/form-data' id='compare-"+productJSONs[prod].handle+"' class='compare-col grid-item'></form>");
            comparecol.append('<input type="hidden" name="form_type" value="product">');
            comparecol.append('<input type="hidden" name="utf8" value="✓">');
            comparecol.append('<input type="hidden" name="properties[_addedfrompage]" value="comparison">');
            comparecol.append('<input type="hidden" name="quantity" value="1" tabindex="0">');
            comparecol.append('<input type="hidden" name="id" value="' +  productJSONs[prod].variants[0].id  +  '" tabindex="0">');
            // x btn
            $(comparecol).append("<div style='text-align: right; position: absolute; position: absolute; right: -5px; top: 0px;'><button class='compare-remove-btn' data-handle='"+productJSONs[prod].handle+"'><i class='fa-solid fa-xmark'></i></button></div>");
            // image
            $(comparecol).append($("<div style='margin: 0px 20px;'><a href='/products/"+productJSONs[prod].handle+"' style='flex: 1; text-align: center;' ><img src='"+productJSONs[prod].featured_image+"' style='width: 100%;' /></a></div>"));

            //title
            $(comparecol).append("<div style='display: flex; '><a href='/products/"+productJSONs[prod].handle+"' style='flex: 1; text-align: center; font-weight: 600; font-size: 20px; color: #232323; min-height: 75px; align-content: center; padding: 0px 10px' >"+productJSONs[prod].title+"</a></div>");
                     
            
            // reviews
            $(comparecol).append($("<div style='min-height: 20px;'>"+atob(ItemsToCompare[prod].reviews)+"</div>"));
             
            
            
            
            // availability
            if (metadata.pre_order_ship_date)
            {
              $(comparecol).append("<input type='hidden' name='properties[_shipdate]' value='"+metadata.pre_order_ship_date+"'>");
              $(comparecol).append($("<div class='scs-orange' style='align-self: center; align-items: center; display: inline-flex; margin: 0px 20px;'><span class='estimated-circle'><i class='fas fa-circle me-2' style='font-size: 8px;'></i>Estimated to ship "+metadata.pre_order_ship_date+"</span></div>"));
            }
            else if (productJSONs[prod].variants[0].available == false)
            {
              $(comparecol).append($("<div data-availability class='scs-red' style='align-self: center; align-items: center; display: inline-flex; margin: 0px 20px;'><span class='estimated-circle'><i class='fas fa-circle me-1' style='font-size: 8px;'></i>Out of stock</span></div>"));
            }
            else if (productJSONs[prod].variants[0].inventory_quantity <= 0 && productJSONs[prod].variants[0].inventory_policy == "continue")
            {
              let daysfromnow = addWorkDays(new Date(), 14);
              let month = ['Jan' , 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
              daysfromnow = month[daysfromnow.getMonth()] + " " + daysfromnow.getDay(); 
              $(comparecol).append("<input type='hidden' data-shipdays name='properties[_shipdays]' value='14'>");
              $(comparecol).append("<input type='hidden' data-backorder name='properties[_backorder]' value='1'>");
              $(comparecol).append($('<div data-availability class="estimated-circle" style="align-self: center; align-items: center; margin: 0px 20px;"><i class="fas fa-circle me-1" style="font-size: 8px;"></i></span> <span>Estimated to ship '+ daysfromnow +'</span></div>'));  
            }
            else
            {
              $(comparecol).append("<input type='hidden' data-shipdays name='properties[_shipdays]' value='0'>");
              $(comparecol).append("<input type='hidden' data-order name='properties[_backorder]' value='0'>");
              $(comparecol).append($('<div data-availability class="scs-green" style="align-self: center; align-items: center; display: inline-flex; margin: 0px 20px;"><span class="estimated-circle"><i class="fas fa-circle me-1" style="font-size: 8px;"></i></span><span> Ready to ship!</span></div>'));  
            }
            // price
            $(comparecol).append($("<div><span style='text-decoration: line-through;' class='old-price'></span><span class='price price-box'>"+Shopify.formatMoney(productJSONs[prod].price,window.money_format)+"</span></div>"));


            // variants
            let addtorow = $("<div style='padding: 0px 20px; min-height: 35px;" + (multivariantprod ? "" : " display: none;") + "'><select class='select-swatch "+ (productJSONs[prod].variants.length == 1 ? "d-none" : "") + "' name='id' data-id-product='"+productJSONs[prod].id+"'></select></div>");
            productJSONs[prod].variants.forEach((el) => {
              let ispreorder = el.available && el.inventory_management && el.inventory_quantity <=0 ? "1" : 0;
              addtorow.find("select").append("<option data-value='"+el.id+"' value='"+el.id+"' id='"+el.id+"' data-price='"+el.price+"' compareatprice='"+el.compare_at_price+"' data-quantity='"+(el.available ? 1 : 0)+"' data-title='"+el.title+"' data-preorder='"+ispreorder+"'>"+el.title+"</option>") ;
            });
            addtorow.find("select").on("change", function() {
              let selectedOpt = $(this).find("option:selected");
              
              if ($(this).closest("form").find("[data-availability]").length > 0)
              {
                let avail = $(this).closest("form").find("[data-availability]");
                
                if (selectedOpt.attr("data-quantity") > 0 && selectedOpt.attr("data-preorder") == '1' )
                {
                  let daysfromnow = addWorkDays(new Date(), 14);
                  let month = ['Jan' , 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                  daysfromnow = month[daysfromnow.getMonth()] +  " " + daysfromnow.getDay(); 
                  avail.html('<i class="fas fa-circle me-1" style="font-size: 8px;"></i></span> <span>Estimated to ship '+ daysfromnow);
                  avail.removeClass('scs-red').removeClass('scs-green').addClass('scs-orange');
                  $(this).closest("form").find("input[data-shipdays]").prop("value", 14);
                  $(this).closest("form").find("input[data-shipdays]").attr("value", 14);
                  $(this).closest("form").find("input[data-preorder]").prop("value",1);
                  $(this).closest("form").find("input[data-preorder]").attr("value",1);
                }
                else
                {
                  avail.html('<i class="fas fa-circle me-1" style="font-size: 8px;"></i></span> <span>Ready to ship!');
                  avail.removeClass('scs-red').removeClass('scs-orange').addClass('scs-green');
                  $(this).closest("form").find("input[data-shipdays]").prop("value", 0);
                  $(this).closest("form").find("input[data-shipdays]").attr("value", 0);
                  $(this).closest("form").find("input[data-preorder]").prop("value",0);
                  $(this).closest("form").find("input[data-preorder]").attr("value",0);
                }
              }


              // compare at price
              let price = parseInt(selectedOpt.attr("data-price"));
              let cprice = selectedOpt.attr("compareatprice") ? parseInt(selectedOpt.attr("compareatprice")) : price;
              if ( price < cprice) {
                
                $(this).closest("form")
                  .find(".old-price")
                  .html(
                    Shopify.formatMoney(
                      cprice,
                      window.money_format
                    )
                  );
                $(this).closest("form").find(".old-price").addClass("me-2");
                $(this).closest("form").find(".price-box.price").css("color", "red");
              } else {
                $(this).closest("form").find(".old-price").removeClass("me-2");
                $(this).closest("form").find(".old-price").html("");
                $(this).closest("form").find(".price-box.price").css("color", "inherit");
              }
              
            });
            $(comparecol).append(addtorow);
            
            $(comparecol).append("<div style='padding: 0px 20px;'><button style='width: 100%;' data-btn-addtocart type='submit' data-form-id='#compare-"+productJSONs[prod].handle+"' class='btn add-to-cart-btn'>Add To Cart</button></div>");
            
            // properties

            let itemprop = {
              "exterior_finish": "Exterior Finish",
              "magnets": "Magnets",
              "maglev": "MagLev", 
              "magnetic_core": "Core Magnets",
              "ball_core": "Ball-Core"
                           };

            let itemproptooltip = {
              "exterior_finish": "Frosted: Matte plastic, medium grip.\nUV Coated: Super glossy plastic, high grip.\nGlossy: Semi-gloss plastic, medium grip.",
              "magnets": "Faster, more accurate turning that 'clicks' into place.",
              "maglev": "Fastest turning, springs replaced by repelling magnets.", 
              "magnetic_core": "Auto-alignment, increased stability.",
              "ball_core": ""  //"Auto-alignment, increased stability, core magnets."
                           };
            function capitalizeFirstLetter(val) {
                return String(val).charAt(0).toUpperCase() + String(val).slice(1);
            }
            
            Object.keys(itemprop).forEach(function(el){
              try {
                let tooltip = 'data-toggle="tooltip" data-placement="top" title="'+ itemproptooltip[el] +'"';

                

                
                if (metadata.hasOwnProperty(el))
                {
                  if (el == "ball_core")
                  {
                    $(comparecol).append("<div>"+itemprop[el]+" : " + 
                                       (metadata[el] ? '<i class="fa-solid fa-check"></i>' : '<i class="fa-solid fa-xmark"></i>') + 
                                       "</div>");
                  } else
                  if (el == "exterior_finish")
                  {
                     $(comparecol).append("<div "+tooltip+"><i class=\"fa-solid fa-circle-info me-2\"></i>"+itemprop[el]+" : " +
                                           metadata[el] + "</div>");
                  } else if (el == "magnets")
                  {
                    $(comparecol).append("<div "+tooltip+"><i class=\"fa-solid fa-circle-info me-2\"></i>"+itemprop[el]+" : " + 
                                       metadata[el] + "</div>");
                  }
                  else
                  {
                    $(comparecol).append("<div "+tooltip+"><i class=\"fa-solid fa-circle-info me-2\"></i>"+itemprop[el]+" : " + 
                                       (metadata[el] ? '<i class="fa-solid fa-check"></i>' : '<i class="fa-solid fa-xmark"></i>') + 
                                       "</div>");
                  }
                  return;
                }
                if (el == "exterior_finish")
                {
                  $(comparecol).append("<div "+tooltip+"><i class=\"fa-solid fa-circle-info me-2\"></i>"+itemprop[el]+' : N/A</div>');
                  return;
                }

                if (el == "ball_core")
                  {
                    $(comparecol).append("<div>"+itemprop[el]+" : " + '<i class="fa-solid fa-xmark"></i>' +           "</div>");
                    return;
                  }
                $(comparecol).append("<div "+tooltip+"><i class=\"fa-solid fa-circle-info me-2\"></i>"+itemprop[el]+' : <i class="fa-solid fa-xmark"></i></div>');
                return;
              
              } catch (error) {
                console.log(error);
              }
              
              
            });
          
            
            
            // Size
            if (metadata.size_in_mm)
            {
              $(comparecol).append("<div>Size: "+ metadata.size_in_mm.value + metadata.size_in_mm.unit + "</div>");
            }
            else
            {
              $(comparecol).append("<div>Size: N/A</div>");
            }
            
            // Weight
            if (metadata.weight)
            {
              $(comparecol).append("<div>Weight: "+ metadata.weight.value + metadata.weight.unit +"</div>");
            }
            else
            {
              $(comparecol).append("<div>Weight: N/A</div>");
            }
                       
            // release date
            $(comparecol).append("<div>Release: "+(metadata.release_date ?? "N/A")+"</div>");
            
            // video
            if (metadata.youtube_review_embed_code)
            {
              $(comparecol).append('<div><div style="width: 90%; justify-self: center;">'+metadata.youtube_review_embed_code.replace("width=","width='95%' data-wid=").replace("height=","height='auto' data-hei=")+'</div></div>');
            }
            else
            {
              $(comparecol).append('<div></div>');
            }
            $(row).append(comparecol);
          }
          $("#compare-table").append(row);
          $("#compare-table .select-swatch").trigger("change");
          $('#compare-table [data-toggle="tooltip"]').tooltip({container: 'body'}); 
        
          hideLoading();
        
        
          $(".compare-modal").fadeIn();

          row.slick({
            slidesToShow: 3,
            get nextArrow() {
                          return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>';
                    },
            get prevArrow() {
              return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>';
            },
            responsive: [
                        {
                            breakpoint: 1400,
                            settings: {
                                get slidesToShow() {
                                    return this.slidesToShow = 3;
                                },
                                get slidesToScroll() {
                                  return this.slidesToScroll = 3;
                                },
                            }
                            },
                            {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                                arrows:false,
                                dots: false              
                            }
                            },
                            {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                arrows:false,
                                dots: false                
                            }
                            },
                            {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows:false,
                                dots: false
                            }
                            }
                        ]
          });
          $(".compare-remove-btn:not(.initialized)").on("click", function () {

            try {
              let itemhandle = $(this).attr("data-handle");
              
              $("#compare-item[data-handle="+itemhandle+"]").prop("checked",false);
              $("#compare-item[data-handle="+itemhandle+"]").attr("checked",false);
            } catch (error) {
              
            }

            
            $(this).addClass("initialized");
            delete ItemsToCompare[$(this).attr('data-handle')];
            localStorage.setItem("ItemsToCompare", JSON.stringify(ItemsToCompare));
            $("#comparebutton").click();
            $(".comparebuttonamount").text(Object.keys(ItemsToCompare).length);
            if (Object.keys(ItemsToCompare).length > 1) {
              $("#comparebutton").addClass("fa-bounce");
            } else {
              $("#comparebutton").removeClass("fa-bounce");
            }

          });

        
      }); // end of productInfos

      
      
    });

    
    
    $("#close-compare-modal").click(function (e) {
      $(".compare-modal").fadeOut();
    });
    
    $(".compare-modal").click(function (e) {
      if(e.target !== e.currentTarget) return;
      $(".compare-modal").fadeOut();
    
    });

  
    let ItemsToCompare = localStorage.getItem("ItemsToCompare") || "{}";
    try {
      ItemsToCompare = JSON.parse(ItemsToCompare);
    } catch (err) {
      ItemsToCompare = {};
    }
    $(".comparebuttonamount").text(Object.keys(ItemsToCompare).length);
  });
});